module.exports = __webpack_public_path__ + "img/chevron-down-black.13cb108e.svg";